namespace GeniuzPOS.AdvPromo {
    export namespace PsAdvPromoHd6Service {
        export const baseUrl = 'AdvPromo/PsAdvPromoHd6';

        export declare function Create(request: Serenity.SaveRequest<PsAdvPromoHd6Row>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsAdvPromoHd6Row>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsAdvPromoHd6Row>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsAdvPromoHd6Row>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/PsAdvPromoHd6/Create",
            Update = "AdvPromo/PsAdvPromoHd6/Update",
            Delete = "AdvPromo/PsAdvPromoHd6/Delete",
            Retrieve = "AdvPromo/PsAdvPromoHd6/Retrieve",
            List = "AdvPromo/PsAdvPromoHd6/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsAdvPromoHd6Service)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
